
import React from 'react';
import { Input } from '@/components/ui/input';
import { Search } from 'lucide-react';

interface SellerProcurementSearchProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
}

const SellerProcurementSearch: React.FC<SellerProcurementSearchProps> = ({
  searchTerm,
  setSearchTerm
}) => {
  return (
    <div className="relative flex-1 max-w-sm">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
      <Input
        type="text"
        placeholder="Search by product, source, or ID..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="pl-10"
      />
    </div>
  );
};

export default SellerProcurementSearch;
